(() => {
	function initImgVideoSwiper() {
		const swiperContainer = document.querySelector('.img-video__track.swiper');
		if (!swiperContainer) return;

		const slideCount = swiperContainer.dataset.slidecount;

		new Swiper(swiperContainer, {
			slidesPerView: 1.3, 
			spaceBetween: 16,
			
			centeredSlidesBounds: true,
			pagination: {
				el: swiperContainer.parentElement.querySelector('.swiper-pagination'),
				clickable: true,
			},
			navigation: {
				nextEl: swiperContainer.parentElement.querySelector('.swiper-button-next'),
				prevEl: swiperContainer.parentElement.querySelector('.swiper-button-prev'),
			},

			breakpoints: {
				700: {
					slidesPerView: 2.3,
				},
				998: {
					slidesPerView: slideCount,
				},
			},
		});
	}

	function setupVideoAutoplayOnVisible() {
		const videos = document.querySelectorAll('.img-video__video');
		if (!('IntersectionObserver' in window) || !videos.length) return;
	  
		const observer = new IntersectionObserver((entries) => {
		  entries.forEach(entry => {
			const video = entry.target;
			if (entry.isIntersecting) {
			  if (video.paused) {
				video.play();
			  }
			} else {
			  if (!video.paused) {
				video.pause();
			  }
			}
		  });
		}, {
		  threshold: 0.25
		});
	  
		videos.forEach(video => observer.observe(video));
	  }
	  
	  setupVideoAutoplayOnVisible();

	  function enforceOwnFontSize() {
		const width = window.innerWidth;
		
		document.querySelectorAll('.img-video__heading').forEach(function(el) {
			let size;
			if (width <= 767) {
				size = 'var(--heading-size-mobile)';
			} else if (width < 1100) {
				size = '22px';
			} else {
				size = 'var(--heading-size-desktop)';
			}
			el.style.setProperty('font-size', size, 'important');
		});
		
		document.querySelectorAll('.img-video__description').forEach(function(el) {
			const isMobile = width <= 767;
			el.style.setProperty(
				'font-size',
				isMobile ? 'var(--description-size-mobile)' : 'var(--description-size-desktop)',
				'important'
			);
		});
	}
	  
	  const observer = new MutationObserver(enforceOwnFontSize);
	  document.querySelectorAll('.img-video__inner').forEach(function(el) {
		observer.observe(el, { 
		  subtree: true,
		  attributes: true,
		  attributeFilter: ['style'] 
		});
	  });
	  
	  enforceOwnFontSize();

	document.addEventListener('DOMContentLoaded', initImgVideoSwiper);
	document.addEventListener('shopify:section:load', initImgVideoSwiper);
	document.addEventListener('shopify:section:reorder', initImgVideoSwiper);
})();
